module.exports = {
  filterAjaxList: [
    {
      url: '/api/backstage/role/list',
      method: 'post',
      param: {
        startPageNum: 1,
        pageSize: 100
      },
      flagKey: 'roleCode',
      id: 'roleCode',
      name: 'name'
    }
  ],
  filterForm: [
    {
      id: 'account',
      label: '账户',
      type: 'input',
      placeholder: '必填，不可重复',
      clearable: true,
      isRequired: true,
      noInsert: true,
      width: '500px'
    }, {
      id: 'name',
      label: '姓名',
      type: 'input',
      width: '500px'
    }, {
      id: 'mobile',
      label: '手机号码',
      type: 'input',
      width: '500px'
    }, {
      id: 'affiliation',
      label: '所属机构',
      type: 'input',
      width: '500px'
    }, {
      id: 'roleCode',
      label: '角色',
      type: 'select',
      isRequired: true,
      width: '500px'
    }, {
      id: 'enable',
      label: '状态',
      type: 'select',
      isRequired: true,
      width: '500px',
      intValue: '1',
      children: [
        {
          id: '1',
          name: '启用'
        },
        {
          id: '0',
          name: '停用'
        }
      ]
    }, {
      id: 'password',
      label: '密码',
      type: 'input',
      isVisible: false,
      inpType: 'password',
      visibleType: 'password',
      validateType: 'password',
      clearable: true,
      width: '500px',
      modelHide: 'add'
    }, {
      id: 'checkPass',
      label: '确认密码',
      type: 'input',
      isVisible: false,
      inpType: 'password',
      visibleType: 'password',
      validateType: 'checkPass',
      clearable: true,
      width: '500px',
      modelHide: 'add'
    }
  ],
  formRules: {
    account: [
      {
        required: true,
        message: '请输入'
      },
      {
        min: 8,
        max: 20,
        message: '必填，8-20个字符，可由数字、下划线、英文字母组成',
        trigger: 'blur'
      },
      {
        pattern: '/^[a-zA-Z0-9_]{8,}$/',
        message: '必填，8-20个字符，可由数字、下划线、英文字母组成',
        trigger: 'change'
      }
    ],
    mobile: [
      {
        pattern: '/^1[3|4|5|6|7|8|9][0-9]{9}$/',
        message: '请输入11位手机号',
        trigger: 'blur'
      }
    ],
    roleCode: [
      {
        required: true,
        message: '请选择'
      }
    ],
    enable: [
      {
        required: true,
        message: '请选择'
      }
    ],
    password: [
      {
        required: true,
        message: '请输入'
      },
      {
        min: 6,
        message: '必填，至少6个字符，可由数字、大写字母、小写字母或特殊字符组成',
        trigger: 'blur'
      }
    ],
    checkPass: [
      {
        required: true,
        message: '请输入'
      }
    ]
  }
}
